import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import ASP from '../views/asp/index'
import SRSO from '../views/srso/index.vue'
import TIPS from '../views/tips/index.vue'
import DRIVERS from '../views/drivers/index.vue'
import REVERVATION from '../views/reserve/index.vue'
import FEEDBACK from '../views/feedback/index.vue'
import FEEDBACKAPP from '../views/feedbackapp/index.vue'
import LOGIN from '../views/login/index.vue'
import NEWSR from '../views/reserve/order.vue'
import RODETAIL from '../views/reserve/orderdetail.vue'
import MSGINFO from '../views/feedback/msginfo.vue'
import NEWMSG from '../views/feedback/newmsg.vue'
import OOW from '../views/oow/index.vue'
import OOWINFO from '../views/oow/info.vue'
import INWPOLICY from '../views/policy/index.vue'
import NEWOOWSO from '../views/oow/neworder.vue'
import MYPROS from '../views/oow/myproducts.vue'
import SURVEY from '../views/srso/survey.vue'
import SURVEYSHOW from '../views/srso/surveyshow.vue'
import REGISTER from '../views/register/index.vue'
import ProductInfo from '../views/productinfo/index.vue'
import openPDF from '../views/productinfo/openpdf.vue'
import showContents from '../views/productinfo/showContents.vue'
import showArticle from '../views/productinfo/showArticle.vue'
import showVideo from '../views/productinfo/showVideo.vue'
import shipinfo from '../views/shipinfo/index.vue'
import apps from '../views/apps/index.vue'
import qa from '../views/qa/index.vue'
import RegisterNewDevice from '../views/register/detail.vue'
import SNFeedback from '../views/register/SNFeedback.vue'

Vue.use(Router)

// 路由导航冗余报错（路由重复）
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                title: '首页'
            }
        },
        {
            path: '/asp',
            name: 'asp',
            component: ASP,
            meta: {
                title: '服务网络'
            }
        },
        {
            path: '/srso',
            name: 'srso',
            component: SRSO,
            meta: {
                title: '工单列表',
                requireAuth: true  // 需要登录
            }
        },
        {
            path: '/tips',
            name: 'tips',
            component: TIPS,
            meta: {
                title: '使用帮助'
            }
        },
        {
            path: '/drivers',
            name: 'drivers',
            component: DRIVERS,
            meta: {
                title: '驱动下载'
            }
        },
        {
            path: '/reserve',
            name: 'reserve',
            component: REVERVATION,
            meta: {
                title: '我的预约',
                requireAuth: true  // 需要登录
            }
        },
        {
            path: '/reserve/order',
            name: 'newsr',
            component: NEWSR,
            meta: {
                title: '新预约',
                requireAuth: true  // 需要登录
            }
        },
        {
            path: '/reserve/orderdetail',
            name: 'orderdetail',
            component: RODETAIL,
            meta: {
                title: '订单详情',
                requireAuth: true  // 需要登录
            }
        },
        {
            path: '/login',
            name: 'login',
            component: LOGIN,
            meta: {
                title: '用户登录'
            }
        },
        {
            path: '/feedback',
            name: 'feedback',
            component: FEEDBACK,
            meta: {
                title: '建议反馈',
                requireAuth: true  // 需要登录
            }
        },
        {
            path: '/feedbackapp',
            name: 'feedbackapp',
            component: FEEDBACKAPP,
            meta: {
                title: '建议反馈'
            }
        },
        {
            path: '/feedback/msginfo',
            name: 'msginfo',
            component: MSGINFO,
            meta: {
                title: '建议详情',
                requireAuth: true  // 需要登录
            }
        },
        {
            path: '/feedback/newmsg',
            name: 'newmsg',
            component: NEWMSG,
            meta: {
                title: '新建议',
                requireAuth: true  // 需要登录
            }
        },
        {
            path: '/oow',
            name: 'oow',
            component: OOW,
            meta: {
                title: '延保产品'
            }
        },
        {
            path: '/oow/info',
            name: 'info',
            component: OOWINFO,
            meta: {
                title: '延保产品'
            }
        },
        {
            path: '/oow/newso',
            name: 'newoowso',
            component: NEWOOWSO,
            meta: {
                title: '延保订单',
                requireAuth: true  // 需要登录
            }
        },
        {
            path: '/oow/mypros',
            name: 'mypros',
            component: MYPROS,
            meta: {
                title: '延保订单',
                requireAuth: true  // 需要登录
            }
        },
        {
            path: '/policy',
            name: 'inwpolicy',
            component: INWPOLICY,
            meta: {
                title: '服务政策'
            }
        },
        {
            path: '/srso/survey',
            name: 'survey',
            component: SURVEY,
            meta: {
                title: '服务反馈',
                requireAuth: true  // 需要登录
            }
        },
        {
            path: '/srso/surveyshow',
            name: 'surveyshow',
            component: SURVEYSHOW,
            meta: {
                title: '服务反馈',
                requireAuth: true  // 需要登录
            }
        },
        {
            path: '/register',
            name: 'register',
            component: REGISTER,
            meta: {
                title: '产品注册',
                requireAuth: true  // 需要登录
            }
        },
         {
            path: '/register/detail',
            name: 'newregister',
            component: RegisterNewDevice,
            meta: {
                title: '产品注册',
                requireAuth: true  // 需要登录
            }
        },    
          {
            path: '/register/SNFeedback',
            name: 'SNFeedback',
            component: SNFeedback,
            meta: {
                title: '产品注册',
                requireAuth: true  // 需要登录
            }
        },          
        {
            path: '/productinfo',
            name: 'ProductInfo',
            component: ProductInfo,
            meta: {
                title: '产品信息'
            }
        },
        {
            path: '/productinfo/openPDF',
            name: 'openPDF',
            component: openPDF,
            meta: {
                title: '文件查看'
            }
        },
        {
            path: '/productinfo/showContents',
            name: 'showContents',
            component: showContents,
            meta: {
                title: '文件查看'
            }
        },
        {
            path: '/productinfo/showArticle',
            name: 'showArticle',
            component: showArticle,
            meta: {
                title: '手册指南'
            }
        },
        {
            path: '/productinfo/showVideo',
            name: 'showVideo',
            component: showVideo,
            meta: {
                title: '安装视频'
            }
        },
        {
            path: '/shipinfo',
            name: 'shipinfo',
            component: shipinfo,
            meta: {
                title: '保修查询'
            }
        },
        {
            path: '/apps',
            name: 'apps',
            component: apps,
            meta: {
                title: 'APP下载'
            }
        },
        {
            path: '/qa',
            name: 'qa',
            component: qa,
            meta: {
                title: '问答'
            }
        }
    ]
})

// 路由守卫 - 登录验证
router.beforeEach((to, from, next) => {
    // 设置页面标题
    if (to.meta.title) {
        document.title = to.meta.title
    }

    // 检查路由是否需要登录
    if (to.meta.requireAuth) {
        const isLogin = localStorage.getItem('isLogin') === '1'
        const accessToken = localStorage.getItem('access_token')
        
        if (isLogin && accessToken) {
            // 已登录，允许访问
            next()
        } else {
            // 未登录，跳转到登录页
            next({
                path: '/login',
                query: { 
                    redirect: to.fullPath  // 保存目标路径，登录后可以跳转回来
                }
            })
        }
    } else {
        // 不需要登录的路由，直接放行
        next()
    }
})

// 路由后置钩子
router.afterEach((to, from) => {
    // 可以在这里添加页面访问统计等
})

export default router